define(['santa-components', 'lodash', 'coreUtils', 'socialCommon', 'skins', 'pinterestPinIt/skins/skins.json', 'componentsCore'], function (santaComponents, _, coreUtils, socialCommon, skinsPackage, skinsJson, componentsCore) {
    'use strict';

    const urlUtils = coreUtils.urlUtils;

    const BUTTON_SIZES = {
        none: {
            small: {
                width: 50,
                height: 20
            },
            large: {
                width: 67,
                height: 28
            }
        },
        above: {
            small: {
                width: 50,
                height: 56
            },
            large: {
                width: 67,
                height: 78
            }
        }
    };

    function getButtonDimension(counterPosition, size) {
        return BUTTON_SIZES[counterPosition][size];
    }

    function getIframeSrc(props, url) {
        let iframeSrc = `${props.santaBase}/static/external/pinterestPinIt.html?`;
        if (_.isEmpty(props.compData.uri) || _.isEmpty(props.compData.description)) {
            iframeSrc += urlUtils.toQueryString(getEmptyIframeParams(props));
        } else {
            iframeSrc += urlUtils.toQueryString(getIframeParams(props, url));
        }
        return iframeSrc;
    }

    function getEmptyIframeParams(props) {
        const noneOrAbove = props.compProp.counterPosition;
        const size = props.compProp.size;
        return {
            gagPath: coreUtils.media.getMediaUrl(props.serviceTopology, `pinterestPinIt/pinterestDisabled-${noneOrAbove}-${size}.png`)
        };
    }

    function getIframeParams(props, url) {
        return {
            media: urlUtils.addProtocolIfMissing(`${props.serviceTopology.staticMediaUrl}/${props.compData.uri}`),
            url,
            description: props.compData.description,
            'data-pin-do': 'buttonBookmark',
            'data-pin-config': props.compProp.counterPosition,
            'data-pin-color': props.compProp.color,
            'data-pin-height': getButtonDimension('none', props.compProp.size).height
        };
    }

    /**
     * @class components.PinterestPinIt
     * @extends {core.skinBasedComp}
     */
    const pinterestPinIt = {
        displayName: 'PinterestPinIt',
        mixins: [componentsCore.mixins.skinBasedComp, socialCommon.socialCompMixin],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            santaBase: santaComponents.santaTypesDefinitions.santaBase.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            serviceTopology: santaComponents.santaTypesDefinitions.ServiceTopology.serviceTopology
        },

        getSkinProperties() {
            if (!['none', 'above'].includes(this.props.compProp.counterPosition)) {
                this.props.compProp.counterPosition = 'none';
            }
            const size = getButtonDimension(this.props.compProp.counterPosition, this.props.compProp.size);
            const height = size.height;
            const width = size.width;
            const a11yTitle = 'Pin to Pinterest';
            const iframeSrc = getIframeSrc(this.props, this.getSocialUrl(true));

            return {
                '': {
                    style: {
                        height,
                        width
                    },
                    title: a11yTitle,
                    'aria-label': a11yTitle,
                    'data-src': iframeSrc,
                    tagName: 'wix-iframe'
                },
                iframe: {
                    width,
                    height,
                    'data-src': iframeSrc,
                    title: a11yTitle,
                    'aria-label': a11yTitle
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt', pinterestPinIt);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return pinterestPinIt;
});
